import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

export const SendMail = (data) => {
  return axios.post(`${aspNetUrl}mail`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
